module.exports = __webpack_public_path__ + "img/我的盒柜.8db904cb.png";